import { ENDPOINTS } from '../utils/endpoints'
import { postAPIwithToken, patchAPIwithToken, deleteAPIwithToken } from '../utils/fetchApi'

// --- Interfaces ---

export interface UserScope {
  id?: number
  zoneId: number | null
  zoneName?: string | null
  subZoneId: number | null
  subZoneName?: string | null
  cityId: number | null
  cityName?: string | null
  areaId: number | null
  areaName?: string | null
  routeId: number | null
  routeName?: string | null
}

export interface UserRole {
  id: number
  name: string
}

export interface UserManager {
  id: number
  userId: string | null
  name: string
}

export interface User {
  id: number
  userId: string | null
  employeeId: string | null
  username: string | null
  name: string
  email: string
  phone: string
  address: string | null
  designation: string | null
  status: string
  role?: UserRole
  manager?: UserManager
  scopes?: UserScope[]
  dateOfBirth?: string
  imei?: string
  createdAt?: string
  updatedAt?: string
}

export interface GetUsersResponse {
  status: string
  message: string
  data: {
    users: User[]
  }
}

export interface CreateUserPayload {
  name: string
  userId: string
  password?: string
  roleName?: string
  roleIds?: number[]
  email?: string
  phone?: string
  employeeId?: string
  designation?: string
  dateOfBirth?: string
  imei?: string
  address?: string
  managerId?: number | null
  scopes?: {
    zoneId: number | null
    subZoneId: number | null
    cityId: number | null
    areaId: number | null
    routeId: number | null
  }[]
  status?: string
}

export interface CreateUserResponse {
  status: string
  message: string
  data?: any
}

export interface UpdateUserPayload {
  id: number
  name?: string
  userId?: string
  password?: string
  roleName?: string
  email?: string
  phone?: string
  employeeId?: string
  designation?: string
  dateOfBirth?: string
  imei?: string
  address?: string
  managerId?: number
  scopes?: {
    zoneId: number | null
    subZoneId: number | null
    cityId: number | null
    areaId: number | null
    routeId: number | null
  }[]
}

export interface UpdateUserResponse {
  status: string
  message: string
  data?: any
}

export interface DeleteUserPayload {
  id: number
}

export interface DeleteUserResponse {
  status: string
  message: string
  data?: any
}

// --- API Functions ---

export async function getUsers(): Promise<GetUsersResponse> {
  return postAPIwithToken<GetUsersResponse>(ENDPOINTS.USERS)
}

export async function createUser(payload: CreateUserPayload): Promise<CreateUserResponse> {
  return postAPIwithToken<CreateUserResponse>(ENDPOINTS.CREATE_USER, payload)
}

export async function updateUser(payload: UpdateUserPayload): Promise<UpdateUserResponse> {
  return patchAPIwithToken<UpdateUserResponse>(ENDPOINTS.EDIT_USER, payload)
}

export async function deleteUser(id: number): Promise<DeleteUserResponse> {
  return deleteAPIwithToken<DeleteUserResponse>(ENDPOINTS.DELETE_USER, { id })
}
